<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2023-07-27 16:39:35
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-06-07 15:00:54
 * @FilePath: /wemeet-iam/Users/hvv/weMeetSpace/WeMeet_admin_project/wemeet-admin/src/views/brandProduct/components/syncProduct.vue
 * @Description: 
 * Copyright (c) 2023 by WeMeet, All Rights Reserved. 
-->
<template>
  <el-dialog v-model="dialogFormVisible" :title="title" width="800px" @close="close">
    <vab-query-form>
      <vab-query-form-left-panel :span="24">
        <el-form :inline="true" :model="queryForm" @submit.prevent>
          <el-form-item label="产品名称">
            <el-input v-model.trim="queryForm.likeName" clearable placeholder="请输入名称" />
          </el-form-item>
          <el-form-item>
            <el-button :icon="Search" type="primary" @click="queryAllData">查询</el-button>
          </el-form-item>
        </el-form>
      </vab-query-form-left-panel>
    </vab-query-form>

    <el-table
      ref="exhPageTable"
      v-loading="listLoadingExhPage"
      border
      :data="list"
      :row-key="getRowKeys"
      @selection-change="handleSelectionChangeByExhPage"
    >
      <el-table-column type="selection" width="55" />

      <el-table-column align="center" label="产品封面图">
        <template #default="{ row }">
          <el-image :preview-src-list="[row.cover]" :src="row.cover" />
        </template>
      </el-table-column>
      <el-table-column align="center" label="产品名称" prop="productName" show-overflow-tooltip />
      <el-table-column align="center" label="产品类型">
        <template #default="{ row }">
          <el-tag v-for="(item, index) in row.productTypes" :key="index" type="success">
            {{ item }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="状态" prop="status">
        <template #default="{ row }">
          <el-switch v-model="row.status" disabled />
        </template>
      </el-table-column>
      <template #empty>
        <el-empty class="vab-data-empty" description="暂无数据" />
      </template>
    </el-table>
    <el-pagination
      background
      :current-page="queryForm.pageNum"
      :layout="layout"
      :page-size="queryForm.pageSize"
      :total="total"
      @current-change="handleCurrentChangeExhPage"
      @size-change="handleSizeChangeExhPage"
    />
    <template #footer>
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="save">确 定</el-button>
    </template>
  </el-dialog>
</template>

<script>
  import { defineComponent, getCurrentInstance, onMounted, reactive, toRefs } from 'vue'
  import { syncEnterpriseProduct, getAllEnterpriseProduct } from '@/api/brand'

  export default defineComponent({
    name: 'EditSort',
    props: {
      enterpriseCode: {
        type: String,
        default: '',
      },
      exhibitorCode: {
        type: String,
        default: '',
      },
    },
    emits: ['fetch-data'],
    setup(props, { emit }) {
      const { proxy } = getCurrentInstance()

      const state = reactive({
        formRef: null,
        treeRef: null,
        checkMenu: [],
        form: {
          sortNumber: 0,
        },
        rules: {
          sortNumber: [{ required: true, trigger: 'blur', message: '请输入排序' }],
        },
        title: '同步机构产品',
        dialogFormVisible: false,
        list: [],
        flag: '',
        nowSort: '',
        queryForm: {
          pageNum: 1,
          pageSize: 20,
          enterpriseCode: '',
          likeName: '',
        },
        total: 0,
        layout: 'prev, pager, next,jumper',
        listLoadingExhPage: false,
        chooseProductList: [],
      })

      const showEdit = async (row, flag) => {
        state.dialogFormVisible = true
        state.queryForm.pageNum = 1
        queryData()
      }
      const close = () => {
        state.dialogFormVisible = false
      }

      const getRowKeys = (row) => {
        return row.productId
      }
      const queryData = async () => {
        state.listLoadingExhPage = true
        state.queryForm.enterpriseCode = props.enterpriseCode
        const { data } = await getAllEnterpriseProduct(state.queryForm)
        console.log(data)
        state.listLoadingExhPage = false
        state.list = data.data
        state.total = data.total
      }
      const save = async () => {
        let productCodeList = []
        state.chooseProductList.map((val) => {
          productCodeList.push(val.productCode)
        })
        let params = {
          exhibitorCode: props.exhibitorCode,
          productCode: productCodeList,
        }
        let { data } = await syncEnterpriseProduct(params)
        console.log(data)
        proxy.$baseMessage(`修改成功`, 'success', 'vab-hey-message-success')
        emit('fetch-data')
        close()
        return false

        state['formRef'].validate(async (valid) => {
          if (valid) {
            if (state.flag == 'inside') {
              state.form.selfSort = state.form.sortNumber
            } else {
              state.form.sort = state.form.sortNumber
            }
            let { data } = await editBrandProduct(state.form)

            close()
          }
        })
      }

      const handleCurrentChangeExhPage = (val) => {
        state.queryForm.pageNum = val
        queryData()
      }
      const handleSizeChangeExhPage = (val) => {
        state.queryForm.pageSize = val
        queryData()
      }

      const handleSelectionChangeByExhPage = (val) => {
        console.log(val)
        state.chooseProductList = val
      }
      const queryAllData = () => {
        state.queryForm.pageNum = 1
        queryData()
      }
      return {
        ...toRefs(state),
        showEdit,
        close,
        save,
        getRowKeys,
        handleCurrentChangeExhPage,
        handleSizeChangeExhPage,
        handleSelectionChangeByExhPage,
        queryAllData,
      }
    },
  })
</script>

<style lang="scss" scoped>
  .vab-tree-border {
    height: 200px;
    padding: $base-padding;
    overflow-y: auto;
    border: 1px solid #dcdfe6;
    border-radius: $base-border-radius;
  }
</style>
